var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChip2Dollars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 38.4 38.4",
    style: {
      enableBackground: "new 0 0 38.4 38.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B73811;}\n\t.st1{fill:#7C2308;}\n\t.st2{fill:#FF632C;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 19.2,
    cy: 19.2,
    r: 19.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.2,9.6c1.7,0,3.3,0.3,4.8,0.9V0.6C22.5,0.2,20.9,0,19.2,0s-3.3,0.2-4.8,0.6v9.9C15.9,9.9,17.5,9.6,19.2,9.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.2,28.8c-1.7,0-3.3-0.3-4.8-0.9v9.9c1.5,0.4,3.1,0.6,4.8,0.6s3.3-0.2,4.8-0.6v-9.9 C22.5,28.5,20.9,28.8,19.2,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.8,19.2c0,1.7-0.3,3.3-0.9,4.8h9.9c0.4-1.5,0.6-3.1,0.6-4.8s-0.2-3.3-0.6-4.8h-9.9 C28.5,15.9,28.8,17.5,28.8,19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.6,19.2c0-1.7,0.3-3.3,0.9-4.8H0.6C0.2,15.9,0,17.5,0,19.2s0.2,3.3,0.6,4.8h9.9C9.9,22.5,9.6,20.9,9.6,19.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.2,33.6c-7.9,0-14.4-6.5-14.4-14.4S11.3,4.8,19.2,4.8s14.4,6.5,14.4,14.4S27.1,33.6,19.2,33.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M15.1,24.8V24c-1.7-0.1-2.9-0.9-3.2-1.9c-0.1-0.2-0.1-0.3-0.1-0.4c0-0.5,0.3-0.8,0.9-0.8 c0.4,0,0.7,0.2,0.9,0.6c0.2,0.5,0.6,0.9,1.5,1V20l-0.5-0.1c-1.8-0.4-2.8-1.2-2.8-2.7c0-1.6,1.4-2.7,3.3-2.8v-0.8 c0-0.2,0.1-0.4,0.3-0.4s0.3,0.1,0.3,0.4v0.8c1.6,0.1,2.7,0.9,3.1,1.9c0,0.1,0.1,0.3,0.1,0.4c0,0.4-0.3,0.7-0.9,0.7 c-0.4,0-0.7-0.2-0.9-0.6c-0.3-0.6-0.7-0.9-1.3-1v2.4l0.5,0.1c1.9,0.4,2.8,1.2,2.8,2.7c0,1.7-1.4,2.8-3.4,2.9v0.8 c0,0.2-0.1,0.4-0.3,0.4S15.1,25,15.1,24.8z M15.1,18.2v-2.2c-0.9,0.1-1.4,0.5-1.4,1.1S14.2,17.9,15.1,18.2z M15.8,20.1v2.3 c1-0.1,1.5-0.5,1.5-1.1C17.3,20.7,16.9,20.4,15.8,20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M20.7,23.2c0-0.4,0.1-0.6,0.6-1l2.9-2.8c1.2-1.2,1.5-1.6,1.5-2.3c0-0.8-0.6-1.4-1.5-1.4 c-0.8,0-1.3,0.4-1.7,1.2c-0.2,0.4-0.5,0.6-0.9,0.6c-0.5,0-0.9-0.3-0.9-0.8c0-0.2,0-0.3,0.1-0.4c0.3-1.1,1.6-2.1,3.4-2.1 c2.1,0,3.5,1.2,3.5,2.9c0,1.2-0.6,1.9-2.2,3.5l-2.1,2v0h3.7c0.5,0,0.8,0.3,0.8,0.8c0,0.5-0.3,0.8-0.8,0.8h-5.4 C21,24.1,20.7,23.7,20.7,23.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip2Dollars);
export default __webpack_public_path__ + "static/media/chip_2-dollars.a97a262e84d5d8018a86aae1d07e9f39.svg";
export { ForwardRef as ReactComponent };